// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RatingsHighsLows/ratingsHighsLows.scss
// module id = 1415
// module chunks = 10